import Config from './folders.router';
import * as FolderTree from './folder-tree';
import FolderDetails from './folder-details';
import options from './folders.component';

const Component = {
    selector: 'dtFoldersView',
    options
};

export {
    Config,
    Component,
    FolderTree,
    FolderDetails
};



// WEBPACK FOOTER //
// ./app/components/folders-and-labels/folders/index.js